import _flowRight from 'lodash/flowRight';
import _uniqueId from 'lodash/uniqueId';
import { getReviews } from '@homeservices/api-kit/search/reviews/v3';

import { toSnakeCase } from '@/utils/to-snake-case';
import {
  withRequestLifecycle,
  REQUEST_LIFECYCLE,
} from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchReviews';

const emptyArray = [];
const emptyObject = {};

const initialPartialState = {
  status: REQUEST_LIFECYCLE.UNINITIALIZED,
  error: null,
  result: emptyArray,
  aggregation: emptyObject,
  count: 0,
  total: 0,
  hasMore: false,
};

export default {
  namespaced: true,
  state: {
    reviewsKey: _uniqueId(),
  },
  getters: {
    reviewsKey: state => state.reviewsKey,
    getReviewsMetaByBucketName: state => (bucketName) => {
      const { result, ...meta } = state[bucketName] || initialPartialState;

      return meta;
    },
    getRawReviewsByBucketName: state => bucketName =>
      (state[bucketName] || initialPartialState).result,
    getRawReviewsAggregationByBucketName: state => bucketName =>
      (state[bucketName] || initialPartialState).aggregation,
  },
  actions: {
    fetchReviews: _flowRight(
      withRequestLifecycle(MUTATION_KEY),
      () => async (
        context,
        { injected: { performFulfillment }, params = {} }
      ) => {
        const {
          data: { results: result, total, aggregation },
        } = await getReviews(toSnakeCase(params));

        return performFulfillment({
          total,
          result,
          aggregation,
        });
      }
    )(),
    resetReviews: ({ commit }, { bucketName }) =>
      commit('resetReviews', { meta: { bucketName } }),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      const { bucketName } = payload.meta;
      const partialState = state[bucketName] || initialPartialState;
      const result = [
        ...new Set([...partialState.result, ...(payload.result || emptyArray)]),
      ];

      state[bucketName] = {
        ...partialState,
        ...payload,
        result,
        count: result.length,
        hasMore: result.length < payload.total,
      };

      state.reviewsKey = _uniqueId();
    },
    resetReviews (state, { meta }) {
      const { bucketName } = meta;

      state[bucketName] = initialPartialState;
      state[bucketName].meta = meta;

      state.reviewsKey = _uniqueId();
    },
  },
};
